<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <a
    v-if="preview?.image"
    class="orangehrm-buzz-link-preview"
    :href="preview.url"
    target="_blank"
    rel="noopener noreferrer"
    @click.stop
  >
    <img
      :src="preview.image"
      :alt="preview.title || preview.url"
      class="orangehrm-buzz-link-preview-image"
      loading="lazy"
      @error="onImageError"
    />
    <div
      v-if="preview.title || preview.description"
      class="orangehrm-buzz-link-preview-meta"
    >
      <span v-if="preview.title" class="orangehrm-buzz-link-preview-title">
        {{ preview.title }}
      </span>
      <span
        v-if="preview.description"
        class="orangehrm-buzz-link-preview-description"
      >
        {{ preview.description }}
      </span>
    </div>
  </a>
</template>

<script>
import {computed, ref, watch} from 'vue';
import {extractFirstBuzzUrl} from '@/orangehrmBuzzPlugin/util/formatBuzzMentions';
import useBuzzLinkPreview from '@/orangehrmBuzzPlugin/util/composable/useBuzzLinkPreview';

export default {
  name: 'BuzzLinkPreview',

  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const imageFailed = ref(false);
    const url = computed(() => {
      if (props.disabled || !props.text) {
        return null;
      }
      return extractFirstBuzzUrl(props.text);
    });
    const {preview: fetchedPreview} = useBuzzLinkPreview(url);
    const preview = computed(() => {
      if (imageFailed.value) {
        return null;
      }
      return fetchedPreview.value;
    });

    const onImageError = () => {
      imageFailed.value = true;
    };

    watch(url, () => {
      imageFailed.value = false;
    });

    return {
      preview,
      onImageError,
    };
  },
};
</script>

<style src="./buzz-link-preview.scss" lang="scss" scoped></style>
